import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'logSenderText'
})
export class LogSenderTextPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value) return "نامعلوم";
    switch (value) {
      case 1:
      case 6:
        return "سرور";
      case 2: return "ویندوز";
      case 3: return "موبایل";
      case 4: return "کلود";
      case 5: return "اسکجولر";
    }
  }

}
